<i18n>
{
  "en":{
    "userDetail": "User Detail",
    "sortBy": "Sort By",
    "userId": "User Id",
    "heartsPerDay": "Per day",
    "totalCount": "Total count"
    
  },
  "zhHant":{
    "userDetail": "收心詳細記錄",
    "sortBy": "排序",
    "userId": "使用者ID",
    "heartsPerDay": "平均每日",
    "totalCount": "總愛心"
  },
  "ja":{
    "userDetail": "友達別のハート受信記録",
    "sortBy": "並び替え",
    "userId": "ユーザーID",
    "heartsPerDay": "1日あたり",
    "totalCount": "総数"
  },
  "ko":{
    "userDetail": "하트 수신 상세",
    "sortBy": "정렬",
    "userId": "사용자 ID",
    "heartsPerDay": "일평균",
    "totalCount": "총 개수"
  }
}
</i18n>

<template>
  <v-container fluid class="pa-0">
    <v-card class="ma-2">
      <v-card-title class="title">
        {{ $t('userDetail') }}
      </v-card-title>
      <v-layout row wrap class="mt-2 mb-2 pt-2">
        <v-flex xs12 md12 lg12 class="pl-4 mt-2 mb-2">
          <span class="mr-3">{{ $t('sortBy') }}</span>
          <v-btn-toggle>
            <!-- <v-btn
              small
              class="ma-0"
              style="min-width: 0px;"
              @click="sort('userId')"
              >{{ $t("userId") }}</v-btn
            > -->
            <v-btn small class="ma-0" style="min-width: 0px" @click="sort('avg')">{{ $t('heartsPerDay') }}</v-btn>
            <v-btn small class="ma-0" style="min-width: 0px" @click="sort('total')">{{ $t('totalCount') }}</v-btn>
          </v-btn-toggle>
        </v-flex>
        <!-- <v-flex xs12 md12 lg7 class="pl-2 mt-2 mb-2">
          <span class="mr-3">Group Filter</span>
          <v-btn-toggle
            v-model="groupFilter"
            style="width:95%; overflow-x: scroll;"
          >
            <v-btn
              flat
              v-for="(group, groupId) in settings.groups"
              :key="groupId"
              :value="groupId"
              >{{ group.name }}</v-btn
            >
            <br />
          </v-btn-toggle>
        </v-flex> -->
      </v-layout>
      <VirtualList :size="itemHeight" :remain="itemRemain" :bench="itemRemain + 2" ref="virtualList">
        <v-layout class="pr-4 pb-1" row wrap v-for="user in sortedRecord[groupFilter || 'all']" :key="user.userId">
          <v-flex xs8 md3 lg3 class="pl-2 text-xs-center">
            <img :src="userImages[user.userId].big" height="60" />
          </v-flex>
          <v-flex xs4 md2 lg2 class="pl-2">
            {{ $t('heartsPerDay') }}: {{ user.avg.toFixed(2) }}
            <br />
            {{ $t('totalCount') }}: {{ user.total }}
          </v-flex>
          <v-flex xs12 md3 lg3 class="pl-0">
            <TsumLineChart :data="user.days" :min="0" :max="24" :step="6" />
          </v-flex>
          <v-flex xs12 md4 lg4 class="pl-0">
            <TsumPlotXY :bits="user.hours" :height="80" />
          </v-flex>
        </v-layout>
      </VirtualList>
    </v-card>
  </v-container>
</template>

<script>
import BitArray from 'bit-array';
import VirtualList from 'vue-virtual-scroll-list';
import TsumLineChart from './TsumLineChart';
import TsumPlotXY from './TsumPlotXY.vue';

export default {
  components: {
    VirtualList,
    TsumLineChart,
    TsumPlotXY,
  },
  props: ['userImages', 'record', 'settings'],
  data() {
    return {
      users: {}, // {[userId: string]: {days: [], hours: []}}
      sortBy: 'userId', // userId, total, avg
      sortedRecord: {
        all: [],
        g01: [],
        g02: [],
        g03: [],
        g04: [],
        g05: [],
        g06: [],
      },
      groupFilter: '',
      asc: 1, // 1 or -1
    };
  },
  mounted() {
    this.mergeAlias();
    this.sortRecord();
  },
  watch: {
    record: function () {
      for (const userId in this.user) {
        delete this.user[userId];
      }
      this.sortedRecord.all.splice(0, this.sortedRecord.all.length);
      this.sortedRecord.g01.splice(0, this.sortedRecord.g01.length);
      this.sortedRecord.g02.splice(0, this.sortedRecord.g02.length);
      this.sortedRecord.g03.splice(0, this.sortedRecord.g03.length);
      this.sortedRecord.g04.splice(0, this.sortedRecord.g04.length);
      this.sortedRecord.g05.splice(0, this.sortedRecord.g05.length);
      this.sortedRecord.g06.splice(0, this.sortedRecord.g06.length);
      setTimeout(() => {
        this.mergeAlias();
        this.sortRecord();
      }, 300);
    },
  },
  computed: {
    itemHeight() {
      if (window.innerWidth < 768) {
        return 226;
      }
      return 80;
    },
    itemRemain() {
      if (window.innerWidth < 768) {
        return 3;
      }
      return 8;
    },
  },
  methods: {
    update() {
      this.$set(this, 'users', this.users);
    },
    mergeAlias() {
      for (const userId in this.users) {
        delete this.users[userId];
      }
      for (const userId in this.record.receiveDetail) {
        const days = [];
        for (let i = 0; i < 31; i++) {
          days.push(Math.min(24, this.record.receiveUserDays[userId][i]));
        }
        this.$set(this.users, userId, {
          userId: userId,
          days: days,
          hours: this.record.receiveDetail[userId].copy(),
          avg: 0,
          total: 0,
        });
      }
      for (const userId in this.users) {
        const aliasId = this.settings.alias[userId];
        if (aliasId === undefined) {
          continue;
        }
        // user may not exists in the month
        if (this.users[aliasId] === undefined) {
          this.users[aliasId] = this.emptyUser(aliasId);
        }
        this.mergeUser(this.users[userId], this.users[aliasId]);
        delete this.users[userId];
      }
      for (const userId in this.users) {
        const user = this.users[userId];
        this.calculateAvg(user);

        this.sortedRecord.all.push(user);
        for (let groupId in this.settings.groups) {
          const members = this.settings.groups[groupId].members;
          if (members[userId] !== undefined) {
            this.sortedRecord[groupId].push(user);
          }
        }
      }
    },
    mergeUser(fromUser, toUser) {
      for (let i = 0; i < 31; i++) {
        toUser.days[i] = Math.min(24, toUser.days[i] + fromUser.days[i]);
      }
      for (let i = 0; i < 768; i++) {
        if (!fromUser.hours.get(i)) {
          continue;
        }
        let toIdx = i;
        while (toUser.hours.get(toIdx) && toIdx >= 0) {
          toIdx--;
        }
        toUser.hours.set(toIdx, true);
      }
    },
    calculateAvg(user) {
      let sum = 0;
      let count = 0;
      for (let i = 0; i < 31; i++) {
        if (user.days[i] > 0) {
          sum += user.days[i];
          count++;
        }
      }
      user.avg = sum / count;
      user.total = sum;
    },
    sortRecord() {
      for (let groupId in this.sortedRecord) {
        const group = this.sortedRecord[groupId];
        if (this.sortBy === 'userId') {
          group.sort((a, b) => {
            return a.userId < b.userId ? -1 * this.asc : 1 * this.asc;
          });
        } else if (this.sortBy === 'total') {
          group.sort((a, b) => {
            return a.total > b.total ? -1 * this.asc : 1 * this.asc;
          });
        } else if (this.sortBy === 'avg') {
          group.sort((a, b) => {
            return a.avg > b.avg ? -1 * this.asc : 1 * this.asc;
          });
        }
      }
    },
    emptyUser(userId) {
      const days = [];
      for (let i = 0; i < 31; i++) {
        days.push(0);
      }
      return {
        userId: userId,
        days: days,
        hours: new BitArray(768),
        avg: 0,
        total: 0,
      };
    },
    sort(type) {
      if (this.sortBy === type) {
        this.asc *= -1;
      }
      this.sortBy = type;
      this.sortRecord();
    },
  },
};
</script>

<style></style>
